import './message.css';
import { h } from 'preact';

export default function Message({ type, message, useDangerousHtml }) {
	return (
		<div class={'message-container' + (type ? ' message-type-' + type : ' message-type-notice')} dangerouslySetInnerHTML={(useDangerousHtml ? { __html: message } : false)}>
			{!useDangerousHtml ? <p>
				{message}
			</p> : ''}
		</div>
	);
}
